import { render, staticRenderFns } from "./ModalConversa.vue?vue&type=template&id=24d3563f"
import script from "./ModalConversa.vue?vue&type=script&lang=js"
export * from "./ModalConversa.vue?vue&type=script&lang=js"
import style0 from "../styles/conversas-shared.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports